// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

function headerHeight() {
  const header = document.querySelector('.header');
  if (!header) return;
  const calculatedHeight = () => {
    const headerHeight = header.offsetHeight;
    document.documentElement.style.setProperty(
      '--header-height',
      `${headerHeight}px`
    );
  };
  calculatedHeight();
  window.addEventListener('resize', calculatedHeight);
  window.addEventListener('scroll', calculatedHeight);
}

function wooAccordion() {
  const accordion = document.getElementById('wooAccordion');
  if (!accordion) return;

  const toggles = accordion.querySelectorAll('.accordion-toggle');

  toggles.forEach((btn) => {
    const panelId = btn.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);

    if (!panel) {
      console.log('Accordion: panel not found for', panelId);
      return;
    }

    panel.setAttribute('role', 'region');

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      toggle(panel, btn, !isOpen);
    });
  });

  function toggle(panel, btn, toOpen) {
    const chev = btn.querySelector('.chev');
    if (toOpen) {
      panel.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      if (chev) chev.classList.add('open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    } else {
      panel.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      if (chev) chev.classList.remove('open');
      panel.style.maxHeight = null;
    }
  }
}

function initWooSlider() {
  const main = $('.product-gallery__main');
  const thumbs = $('.product-gallery__thumbs');
  if (!thumbs.length || !main.length) return;

  main.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.product-gallery__thumbs',
  });

  thumbs.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-gallery__main',
    focusOnSelect: true,
    arrows: false,
    centerMode: false,
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();

  const trigger = document.getElementById('js-menu-trigger');

  if (trigger) {
    trigger.addEventListener('click', function () {
      document.body.classList.toggle('menu-opened');
    });
  }

  headerHeight();

  wooAccordion();
  initWooSlider();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});

/**
 * Toggle expandable extra content block inside .s-categories section.
 * Handles opening/closing animation state and updates button text.
 */
$('.s-categories__btn').on('click', function (e) {
  e.preventDefault();
  const $contentBlock = $(this)
    .closest('.s-categories__content')
    .find('.s-categories__extra-content');
  if ($contentBlock.length > 0) {
    const isOpen = $contentBlock.hasClass('is-open');
    if (!isOpen) {
      const fullHeight = $contentBlock[0].scrollHeight;
      $contentBlock.css('max-height', fullHeight + 'px');
      $contentBlock.addClass('is-open');
      $(this).find('.read-more-text').css('display', 'none');
      $(this).find('.collapse-text').css('display', 'block');
    } else {
      $contentBlock.css('max-height', '0');
      $contentBlock.removeClass('is-open');
      $(this).find('.read-more-text').css('display', 'block');
      $(this).find('.collapse-text').css('display', 'none');
    }
  }
});
